import { calculateGaugeAngle } from './calculate-gauge-angle.js';
import { polarToCartesian } from './polar-to-cartesian.js';
import type { Line } from '../../core/types/line.js';

/**
 * Calculates the threshold line indicator position.
 *
 * @param thresholdValue -
 * @param min -
 * @param max -
 */
export const calculateThresholdLinePosition = (
  thresholdValue: number,
  min: number,
  max: number,
  arcOuterRadius: number,
  arcInnerRadius: number,
): Line | undefined => {
  if (thresholdValue < min || thresholdValue > max) {
    return undefined;
  }

  const thresholdValueAngle = calculateGaugeAngle(thresholdValue, max, min);

  const proportionFactorInPercentage = 0.05;

  const adjustedInnerOffset = arcInnerRadius * proportionFactorInPercentage;
  const adjustedOuterOffset = arcOuterRadius * proportionFactorInPercentage;

  const { x: x1, y: y1 } = polarToCartesian(
    arcInnerRadius - adjustedInnerOffset,
    thresholdValueAngle,
  );
  const { x: x2, y: y2 } = polarToCartesian(
    arcOuterRadius + adjustedOuterOffset,
    thresholdValueAngle,
  );

  return { start: { x: x1, y: y1 }, end: { x: x2, y: y2 } };
};
